import React from 'react';
import contact from '../../../assets/img/Searchengines-rafiki.png';

import {
  Form,
  Input,
  Row,
  Col, Button
} from 'antd';


class EAD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, States: []
    }
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let email = [];
        email.push({
          emaiL_CODE: values.emaiL_CODEh,
          emaiL_ADDRESS: values.emaiL_ADDRESSh
        });
        email.push({
          emaiL_CODE: values.emaiL_CODEb,
          emaiL_ADDRESS: values.emaiL_ADDRESSb
        });
        this.props.submitHandler({ email: email, website: values.website });
      }
    });
  }
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { predata } = this.props;
    if (this.props.niprappoinment&&this.props.niprappoinment.email){
      let {email,website} =this.props.niprappoinment;
      setTimeout(() => { setFieldsValue({
        emaiL_CODEh:email[0].emaiL_CODE,
        emaiL_ADDRESSh:email[0].emaiL_ADDRESS,
        emaiL_CODEb:email[1].emaiL_CODE,
        emaiL_ADDRESSb:email[1].emaiL_ADDRESS,        
        website:website
      }) }, 100);
    }else{
      setTimeout(() => { setFieldsValue({
        emaiL_ADDRESSh:predata&&predata.email,
        emaiL_ADDRESSb:predata&&predata.email,        
      }) }, 100)
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (

      <div ><Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
        <Row>
          <Col md={10} sm={24}><img className='ant-login-image' alt="example" style={{ width: '450px', margin: '0', height: 450 }} src={contact} />
          </Col>
          <Col md={14} sm={24}>
            <Row>
              <Col md={24} sm={24}>
                <Form.Item>
                {getFieldDecorator('emaiL_CODEh', {
                    initialValue: '01'
                  })(
                    <Input hidden />
                  )}
                </Form.Item>
                <Form.Item>
                
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Personal Email *</legend>
                    {getFieldDecorator('emaiL_ADDRESSh', {
                      rules: [{ required: true, message: 'Please enter Enter Personal Email' }, {
                        pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                        message: "Email is not valid"
                      }],
                    })(<Input autoComplete={"nope"} maxLength={256} className="mi_input" type="text" placeholder="Enter Personal Email" />)}
                  </fieldset>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={24} sm={24}>
                <Form.Item>
                {getFieldDecorator('emaiL_CODEb', {
                    initialValue: '02'
                  })(
                    <Input hidden />
                  )}
                </Form.Item>
                <Form.Item>
                
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Business Email *</legend>
                    {getFieldDecorator('emaiL_ADDRESSb', {
                      rules: [{ required: true, message: 'Please enter Enter Business Email' }, {
                        pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                        message: "Email is not valid"
                      }],
                    })(<Input autoComplete={"nope"} maxLength={256} className="mi_input" type="text" placeholder="Enter Business Email" />)}
                  </fieldset>
                </Form.Item>
              </Col>
            </Row>
            {/* <Row>
<Col md={24} sm={24}>
 <Form.Item>
   <fieldset  className="mi_input_pop">
     <legend className="legend-font">Business Entity Name
</legend>
     {getFieldDecorator('business_entity_name', {
       rules: [{ required: false, message: 'Please enter Enter Business Entity Name' }, {
         pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
         message: "It allows only Alphabets"
       }],
     })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder="Enter Business Entity Name"  />)}
   </fieldset>
 </Form.Item>
</Col></Row> */}
            <Row>
              <Col md={24} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Business Web Address</legend>
                    {getFieldDecorator('website', {
                     
                    })(<Input autoComplete={"nope"} maxLength={50} className="mi_input" type="text" placeholder="https://nipr.com" />)}
                  </fieldset>
                </Form.Item>
              </Col>
            </Row>
          </Col></Row>

        <div className="collapsepanel-footer">
          <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={()=>this.props.back("exp")}> Back</Button>
          <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}> Next</Button>
        </div>

      </Form>

      </div>

    )
  }
}
const NiprWebInformation = Form.create()(EAD);


export default NiprWebInformation;
